import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  discoveryBoxBrand: {
    id: 'checkout.cartPage.discoveryBox.discoveryBoxBrand',
    defaultMessage: 'Discovery Box',
    description: 'DiscoveryBox Brand',
  },
  discoveryBoxName: {
    id: 'checkout.cartPage.discoveryBox.discoveryBoxName',
    defaultMessage: 'Notino',
    description: 'DiscoveryBox Name',
  },
  discoveryBoxSubName: {
    id: 'checkout.cartPage.discoveryBox.discoveryBoxSubName',
    defaultMessage: 'Selected package of samples',
    description: 'DiscoveryBox SubName',
  },
  viewItem: {
    id: 'checkout.cartPage.discoveryBox.viewItem',
    defaultMessage: 'Show samples',
    description: 'This messages is going to be shown when discovery box products are available',
  },
  removeProduct: {
    id: 'checkout.cartPage.discoveryBox.removeProduct',
    defaultMessage: 'Contains unavailable sample',
    description: 'This messages is going to be shown when discovery box products are NOT available',
  },
});
